export default __webpack_public_path__ + "static/media/tonghuazhong.15bb2043.gif";